import styled from "styled-components";

/**
 * Wrapper principal da seção promocional
 */
export const StyledHeroWrapper = styled.div`
  padding-top: ${({ theme }) => theme.spacing(4)};
  flex-direction: column;
  align-items: center;
  display: flex;
`;

/**
 * Wrapper do título
 */
export const StyledTitleWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "maxWidth",
})<{ maxWidth?: number }>`
  max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}px` : "100%")};
  padding: ${({ theme }) => theme.spacing(4)} ${({ theme }) => theme.spacing(8)};
  flex-direction: column;
  display: flex;
  margin: 0 auto;
  width: 100%;
  /* background-color: ${({ theme }) => theme.colors.mediumBlue}; */

  @media (max-width: ${({ theme }) => theme.breakpoints.xxl}) {
    padding: ${({ theme }) => theme.spacing(2)};
  }
`;

export const StyledPromotionTitle = styled.h2`
  align-self: flex-start;
  margin: 0;
  color: ${({ theme }) => theme.colors.mediumBlue};
  font-size: ${({ theme }) => theme.fontSizes.xl2};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  line-height: 1.15;
  text-align: left;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    font-size: 1.75rem;
    line-height: 1.2;
  }
`;

/**
 * Wrapper do subtítulo
 */
export const StyledSubtitleWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "maxWidth",
})<{ maxWidth: number }>`
  max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}px` : "100%")};
  padding: ${({ theme }) => theme.spacing(4)} ${({ theme }) => theme.spacing(8)};
  flex-direction: column;
  display: flex;
  margin: 0 auto;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.xxl}) {
    padding: ${({ theme }) => theme.spacing(2)};
  }
`;

/**
 * Wrapper do botão de ação (CTA)
 */
export const StyledCTAWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing(4)};
`;
